//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import { UserLog, sendCtmEvtLog } from '@/utils/log'

export default {
    computed: {
        auth_headimg () {
            const { headimgurl }  = this.item && this.item.author ? this.item.author : {}
            return headimgurl ? `${headimgurl}?x-oss-process=image/resize,w_48,h_48` : 'https://cdn.vip-wifi.com/fangchan/img/house-detail/tabs/weixin-active.png'
        }
    },
    methods: {
        goDetail (e) {
            const { id, content_body, jump_path } = this.item
            const { article_url, title } = content_body
            this.log()
            let url = `/web_page?link=${encodeURIComponent(article_url)}&title=${encodeURIComponent(title)}&from=weixin_article`
            if (jump_path) {
                url = jump_path
            } else if (this.type) {
                url = `/web_article?id=${id}&title=${encodeURIComponent(title)}&type=${this.type}`
            }
            this.$router.push({
                path: url
            })
        },
        log () {
            const { content_body, content_type, id } = this.item
            UserLog.click_feeds_article(id)
            if (content_type === 'weixin_article') {
                UserLog.click_article(this.type, content_body.id)
            } else if (this.type === 'weixin_articles') {
                UserLog.click_article(this.type, id)
            }
            if (this.$root.__route__) {
                const PAGES_MAP = {
                    'pages/index/main': '首页',
                    'pages/house_circles/main': '房友圈',
                    'pages/building/main': '楼盘详情',
                    'building/business': '商业楼盘详情',
                    'pages/building/article/main': '楼盘文章列表',
                }
                const page = PAGES_MAP[this.$root.__route__]
                if (page) {
                    sendCtmEvtLog(`${page}点击文章`)
                }
            }
        }
    },
    components: {
        CommonImg
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        item: {
            type: Object
        }
    }
}
